import { h } from 'preact';
import { useContext } from 'preact/hooks';
import { PIN_HOVER_STATUS_CHANGED } from '../../../../../../store/types';
import { USER_CLICK, USER_PINS_CLICKED } from '../../../../../../types';
import { IconContext } from '../../../../../common/components/svg/icons/icon-context';
import { TIMELINE_LAYER } from '../../../../../common/constants';
import { usePlayerContext, useStyles } from '../../../../../common/hooks';
import { isValidateKeyboard } from '../../../../../common/utils/keyboard';
import { withBreakPoints } from '../../../../hoc';
import { PIN_SIZE } from '../styles';
import './pins.css';

function Pins({
  pins = [],
  duration
}) {
  const Icon = useContext(IconContext);

  const player = usePlayerContext();
  const size = useStyles()(PIN_SIZE);

  const handleClick = (e, { programDistance, pinsIndex }) => {
    e.stopPropagation();
    e.preventDefault();
    player.userEvents$.next({
      action: USER_PINS_CLICKED,
      value: pinsIndex,
      source: USER_CLICK
    });

    player.seek(Math.abs(duration - programDistance));
  };

  const updatePinHoverState = (state) => {
    player.store.dispatch({
      type: PIN_HOVER_STATUS_CHANGED,
      payload: {
        pinsHovered: state
      }
    });
  };

  if (!pins.length && duration <= 0) {
    return null;
  }

  return (
    <div className="ftv-magneto-pins--container">
      {pins.map(({ position, ...remaining }) => (
        <div
          className="ftv-magneto-pins"
          style={{ left: `${position}%`, zIndex: TIMELINE_LAYER + 2 }}
          role="button"
          onClick={(e) => handleClick(e, remaining)}
          tabIndex={-1}
          onKeyDown={(e) => {
            if (isValidateKeyboard(e)) {
              handleClick(e, remaining);
            }
          }}
          onMouseEnter={() => updatePinHoverState(true)}
          onMouseLeave={() => updatePinHoverState(false)}
        >
          <Icon name="starActive" {...size} />
        </div>
      ))}
    </div>
  );
}

export default withBreakPoints(Pins);
